// import Vue from "vue";
import gcComponent from "./gcPopup";

export default Vue => {
    // console.log(Vue1.component(gcComponent.name, gcComponent));
    // Vue.component(gcComponent.name, gcComponent);
    Vue.component(gcComponent.name, gcComponent);
    // Vue.component(gcComponent.name, gcComponent);
};
